<template>
    <div class="root_page_center wrapper_setting">
        <div class="wrapper_qraccount">
            <div class="content_qraccount">
                <div class="img_nameCompany">
                    <div class="img_company">
                        <img src="../assets/images/logos.png" alt="">
                    </div>
                    <div class="name_company">
                        {{ company_name }}
                    </div>
                </div>
                <div class="item_detail_company">
                    <p>Người đại diện: <span>{{ representative_name }}</span></p>
                </div>
                <div class="item_detail_company">
                    <p>Mã số thuế: <span>{{ tax_code }}</span></p>
                </div>
                <div class="item_detail_company">
                    <p>Số điện thọai: <span>{{ phone_number }}</span></p>
                </div>
                <div class="item_detail_company" v-if="establishment_date != null">
                    <p>Ngày thành lập: <span>{{ formatDate(establishment_date) }}</span></p>
                </div>
                <div class="item_detail_company">
                    <p>Địa chỉ đăng ký: <span>{{ head_office_address }}</span></p>
                </div>
                <div class="code_qr_account" v-if="imgQr != null">
                    <h2>Mã định danh doanh nghiệp <br /> {{ textQr }}</h2>
                    <div class="img_qr_account">
                        <img :src="linkWebAdmin + imgQr" alt="" :class="{active: check == 1}">
                    </div>
                    <p v-if="check == 0">{{ formattedMinutes }}:{{ formattedSeconds }}</p>
                    <p v-else>Mã hết hiệu lực</p>
                    <div class="btn_create_code">
                        <button type="button" @click="goLoadPage()">Tạo mã mới</button>
                    </div>
                </div>
                <div class="code_qr_account" v-else>
                    <h2>Mã định danh doanh nghiệp <br /> {{ textQr }}</h2>
                    <p>Đang cập nhật...</p>
                </div>
                <div class="text_qr_account">
                    Lưu ý: Mã <span>QR</span> chỉ có hiệu lực <span>1 phút,</span> tính từ lúc tạo mã mới. Vui lòng thao tác đúng theo chỉ dẫn của cán bộ phụ trách.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SocketIO from 'socket.io-client'
export default {
    name: 'QrAccount_tool',
    data () {
        return {
            token: window.localStorage.getItem('token'),
            check: 0,
            timeLeft: 60,
            intervalId: null,
            imgQr: null,
            company_name: '',
            representative_name: '',
            tax_code: '',
            phone_number: '',
            establishment_date: '',
            head_office_address: '',
            textQr: '',
            socket: null
        }
    },
    components: {
        
    },
    computed: {
        formattedMinutes() {
            return String(Math.floor(this.timeLeft / 60)).padStart(2, '0');
        },
        formattedSeconds() {
            return String(this.timeLeft % 60).padStart(2, '0');
        }
    },
    mounted () {
        
    },
    created () {
        this.getDataQr()
        this.getDataListInfo()
        this.startCountdown()
        this.socketEventCheck()
    },
    beforeUnmount () {
        clearInterval(this.intervalId);
        if (this.socket) {
            this.socket.disconnect()
        }
    },
    methods: {
        startCountdown() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
            this.intervalId = setInterval(() => {
                if (this.timeLeft > 0) {
                    this.timeLeft--;
                } else {
                    clearInterval(this.intervalId);
                    this.check = 1;
                }
            }, 1000);
        },
        getDataQr () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.imgQr = response.data.data.qr_user
                this.textQr = response.data.data.identifier
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getDataListInfo () {
            this.axios.get(this.api_getBusiness,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                // if (response.data.data) {
                    
                // }
                
                this.company_name = response.data?.data?.company_name
                this.representative_name = response.data?.data?.representative_name
                this.tax_code = response.data?.data?.tax_code
                this.phone_number = response.data?.data?.phone_number
                this.establishment_date = response.data?.data?.establishment_date
                this.head_office_address = response.data?.data?.head_office_address
            })
        },
        formatDate(date) {
            if (!date) return ''
            let allDate = date.split('-')
            return `${allDate[2]}/${allDate[1]}/${allDate[0]}`
        },
        goLoadPage () {
            window.location.reload()
        },
        socketEventCheck () {
            let thiss = this
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_load-business.:ReloadEvent`, function(result) {
                thiss.textQr = result.data.identifier
            });
        },
    }
}
</script>